document.documentElement.classList.add('jk-js');

(function(){
  var body = document.body;
  var finePointer = window.matchMedia && window.matchMedia('(pointer:fine)').matches;
  var cursor = document.querySelector('.jk-cursor');
  var hoverGlyph = '✶';

  if (finePointer && cursor) {
    body.classList.add('jk-custom-cursor');
    var baseGlyph = cursor.textContent || '×';

    window.addEventListener('mousemove', function(event){
      cursor.classList.add('is-on');
      cursor.style.left = event.clientX + 'px';
      cursor.style.top = event.clientY + 'px';
    }, { passive: true });

    document.querySelectorAll('a, button, input, .jk-window-bar, [data-cursor]').forEach(function(el){
      el.addEventListener('mouseenter', function(){
        cursor.classList.add('is-hover');
        cursor.textContent = el.getAttribute('data-cursor') || hoverGlyph;
      });
      el.addEventListener('mouseleave', function(){
        cursor.classList.remove('is-hover');
        cursor.textContent = baseGlyph;
      });
    });
  }

  try {
    if (localStorage.getItem('jk-language') === 'jp') {
      body.classList.add('jk-jp-mode');
    }
  } catch(e) {}

  document.querySelectorAll('.jk-lang-toggle').forEach(function(btn){
    btn.addEventListener('click', function(){
      body.classList.toggle('jk-jp-mode');
      try {
        localStorage.setItem('jk-language', body.classList.contains('jk-jp-mode') ? 'jp' : 'en');
      } catch(e) {}
    });
  });

  var topZ = 30;
  document.querySelectorAll('[data-window]').forEach(function(win){
    win.style.zIndex = win.style.zIndex || 2;
    win.addEventListener('pointerdown', function(){
      win.style.zIndex = ++topZ;
    });

    var bar = win.querySelector('.jk-window-bar');
    if (!bar || !finePointer) return;

    var active = false;
    var startX = 0;
    var startY = 0;
    var baseX = 0;
    var baseY = 0;

    bar.addEventListener('pointerdown', function(event){
      if (event.button !== 0) return;
      if (window.innerWidth < 900) return;
      active = true;
      win.classList.add('is-dragging');
      win.style.zIndex = ++topZ;
      startX = event.clientX;
      startY = event.clientY;
      var transform = win.dataset.translate || '0,0';
      var parts = transform.split(',').map(Number);
      baseX = parts[0] || 0;
      baseY = parts[1] || 0;
      bar.setPointerCapture(event.pointerId);
    });

    bar.addEventListener('pointermove', function(event){
      if (!active) return;
      var dx = event.clientX - startX;
      var dy = event.clientY - startY;
      var x = baseX + dx;
      var y = baseY + dy;
      win.dataset.translate = x + ',' + y;
      win.style.transform = 'translate3d(' + x + 'px,' + y + 'px,0)';
    });

    function endDrag(){
      active = false;
      win.classList.remove('is-dragging');
    }
    bar.addEventListener('pointerup', endDrag);
    bar.addEventListener('pointercancel', endDrag);
  });


  var bgDesktop = document.querySelector('.jk-bg-desktop');
  if (bgDesktop && finePointer) {
    window.addEventListener('mousemove', function(event){
      var px = (event.clientX / window.innerWidth - 0.5) * 14;
      var py = (event.clientY / window.innerHeight - 0.5) * 10;
      bgDesktop.style.transform = 'translate3d(' + px + 'px,' + py + 'px,0)';
    }, { passive: true });
  }

  document.querySelectorAll('[data-product]').forEach(function(card){
    card.addEventListener('mousemove', function(event){
      var rect = card.getBoundingClientRect();
      var x = ((event.clientX - rect.left) / rect.width) * 100;
      var y = ((event.clientY - rect.top) / rect.height) * 100;
      card.style.setProperty('--mx', x + '%');
      card.style.setProperty('--my', y + '%');
    }, { passive: true });

    card.addEventListener('click', function(event){
      if (event.target.closest('a')) return;
      card.classList.toggle('is-revealed');
    });
  });

  var emailModal = document.querySelector('.jk-email-modal');


  function setModal(visible){
    if (!emailModal) return;
    emailModal.classList.toggle('is-visible', visible);
    emailModal.setAttribute('aria-hidden', visible ? 'false' : 'true');
    body.classList.toggle('jk-modal-open', !!visible);
  }

  window.setTimeout(function(){
    try {
      if (sessionStorage.getItem('jk-email-modal-seen') === 'yes') return;
      sessionStorage.setItem('jk-email-modal-seen', 'yes');
    } catch(e) {}
    setModal(true);
  }, 1700);



  document.querySelectorAll('.jk-bg-file[href]').forEach(function(shortcut){
    shortcut.addEventListener('click', function(event){
      event.preventDefault();
      event.stopPropagation();
      var url = shortcut.getAttribute('href');
      if (!url) return;
      if (url === '/#shop' || url === '#shop') {
        window.open(window.location.origin + '/#shop', '_blank', 'noopener');
        return;
      }
      window.open(url, '_blank', 'noopener');
    });
  });

  document.querySelectorAll('[data-open-email-modal]').forEach(function(trigger){
    trigger.addEventListener('click', function(event){
      event.preventDefault();
      setModal(true);
    });
  });

  document.querySelectorAll('[data-close-modal]').forEach(function(btn){
    btn.addEventListener('click', function(){ setModal(false); });
  });

  document.addEventListener('keydown', function(event){
    if (event.key === 'Escape') {
      setModal(false);
    }
  });
})();
